import parallax from './parallax';
import * as Settings from './settings';

const initParallax = () => {
    parallax(Settings.imgRespSettings);
    parallax(Settings.blockQuoteSettings);
}

export default initParallax;